export default __webpack_public_path__ + "static/media/users-icon.f174af05.svg";